/** Semantic badge classes — mamba-platform tokens via Tailwind (info/success/warning/danger/neutral). */

export const BADGE_PILL =
  'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border border-transparent';

/** CRM client / prospect stage */
export function clientStageBadgeClass(stage: string): string {
  switch (stage.toLowerCase()) {
    case 'lead':
      return `${BADGE_PILL} bg-info-bg text-info-fg`;
    case 'prospect':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    case 'client':
      return `${BADGE_PILL} bg-success-bg text-success-fg`;
    case 'churned':
      return `${BADGE_PILL} bg-danger-bg text-danger-fg`;
    default:
      return `${BADGE_PILL} bg-neutral-badge-bg text-neutral-badge-fg`;
  }
}

/** Inbound marketing lead workflow (`crm.Lead.status`) — canonical SMB + legacy aliases */
export function leadWorkflowBadgeClass(status: string, opts?: { converted?: boolean }): string {
  if (opts?.converted) {
    return `${BADGE_PILL} bg-success-bg text-success-fg`;
  }
  const key = status.toLowerCase();
  switch (key) {
    case 'new':
    case 'new_lead':
      return `${BADGE_PILL} bg-info-bg text-info-fg`;
    case 'attempted':
    case 'demo_scheduled':
    case 'demo_completed':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    case 'contacted':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    case 'replied':
    case 'responded':
      return `${BADGE_PILL} bg-primary-muted text-primary`;
    case 'qualified':
    case 'closed_won':
      return `${BADGE_PILL} bg-success-bg text-success-fg`;
    case 'unqualified':
    case 'closed_lost':
      return `${BADGE_PILL} bg-danger-bg text-danger-fg`;
    default:
      return `${BADGE_PILL} bg-neutral-badge-bg text-neutral-badge-fg`;
  }
}

/** Lead source — distinct but token-based (no raw Tailwind palette). */
export function leadSourceBadgeClass(source: string): string {
  switch (source.toLowerCase()) {
    case 'website':
      return `${BADGE_PILL} bg-info-bg text-info-fg`;
    case 'referral':
      return `${BADGE_PILL} bg-success-bg text-success-fg`;
    case 'cold call':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    case 'social media':
      return `${BADGE_PILL} bg-primary-muted text-primary`;
    case 'email':
      return `${BADGE_PILL} bg-neutral-badge-bg text-neutral-badge-fg`;
    case 'door-to-door':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    default:
      return `${BADGE_PILL} bg-neutral-badge-bg text-neutral-badge-fg`;
  }
}

/** Lifecycle status for lead/prospect/client list hygiene. */
export function lifecycleStatusBadgeClass(status: string): string {
  const key = (status || '').toLowerCase();
  switch (key) {
    case 'active':
      return `${BADGE_PILL} bg-success-bg text-success-fg`;
    case 'nurturing':
    case 'paused':
      return `${BADGE_PILL} bg-info-bg text-info-fg`;
    case 'dormant':
      return `${BADGE_PILL} bg-warning-bg text-warning-fg`;
    case 'archived':
    case 'lost':
    case 'former':
    case 'do_not_contact':
      return `${BADGE_PILL} bg-danger-bg text-danger-fg`;
    default:
      return `${BADGE_PILL} bg-neutral-badge-bg text-neutral-badge-fg`;
  }
}
